import Block from 'components/Block'
import TextBody from 'components/TextBody'
import TextTitleCompressedHeavy from 'components/TextTitleCompressedHeavy'
import TextTitleCompressedHeavyUpperCase from 'components/TextTitleCompressedHeavyUpperCase'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import { STYLES_FONT_SIZE } from 'modules/styles/constants/index.cjs'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import { useTheme } from 'modules/styles/index.js'
import { WhoItsBuiltForCTA } from './Cta'

const messages = defineMessages({
  title: {
    id: 'TrackCaloriesWhoItsBuiltFor.title',
    defaultMessage: 'Who Gymaholic Is Built For'
  },
  busyProfessionals: {
    id: 'TrackCaloriesWhoItsBuiltFor.busyProfessionals',
    defaultMessage: 'Busy Professionals'
  },
  busyProfessionalsDescription: {
    id: 'TrackCaloriesWhoItsBuiltFor.busyProfessionalsDescription',
    defaultMessage: 'You don’t have time to spend 10 minutes logging every meal. Track your calories in seconds between meetings or on the go.'
  },
  fitnessEnthusiasts: {
    id: 'TrackCaloriesWhoItsBuiltFor.fitnessEnthusiasts',
    defaultMessage: 'Fitness Enthusiasts'
  },
  fitnessEnthusiastsDescription: {
    id: 'TrackCaloriesWhoItsBuiltFor.fitnessEnthusiastsDescription',
    defaultMessage: 'Hit your protein and macro targets with precision. Perfect for cutting, bulking, or maintaining your physique.'
  },
  beginners: {
    id: 'TrackCaloriesWhoItsBuiltFor.beginners',
    defaultMessage: 'Beginners'
  },
  beginnersDescription: {
    id: 'TrackCaloriesWhoItsBuiltFor.beginnersDescription',
    defaultMessage: 'New to tracking? Our AI makes it effortless. No confusing databases or complicated math - just simple, accurate tracking.'
  }
})

const PERSONAS = [
  {
    titleMessage: messages.busyProfessionals,
    descriptionMessage: messages.busyProfessionalsDescription,
    icon: '💼'
  },
  {
    titleMessage: messages.fitnessEnthusiasts,
    descriptionMessage: messages.fitnessEnthusiastsDescription,
    icon: '💪'
  },
  {
    titleMessage: messages.beginners,
    descriptionMessage: messages.beginnersDescription,
    icon: '🌟'
  }
]

export function TrackCaloriesWhoItsBuiltFor () {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const intl = useIntl()
  const theme = useTheme()

  return (
    <Block
      bgc='backgroundContent'
    >
      <View
        centered
        style={{
          maxWidth: theme.maxWidth.desktopCompact
        }}
      >
        <View
          mb={4}
          style={{
            textAlign: 'center'
          }}
        >
          <TextTitleCompressedHeavy>
            {formatMessageIntlUtil(intl, messages.title)}
          </TextTitleCompressedHeavy>
        </View>
        <View
          row={!isSmallScreen}
          wrap
          style={{
            gap: isSmallScreen ? '1em' : '1.5em'
          }}
        >
          {
            PERSONAS.map((persona, index) => {
              const {
                titleMessage,
                descriptionMessage,
                icon
              } = persona
              return (
                <View
                  key={index}
                  f
                  p={3}
                  style={{
                    backgroundColor: 'white',
                    borderRadius: '0.5em',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    flex: isSmallScreen ? '1 1 100%' : '1 1 calc(50% - 0.75em)',
                    textAlign: 'left'
                  }}
                >
                  <View
                    mb
                    style={{
                      fontSize: '2.5em'
                    }}
                  >
                    {icon}
                  </View>
                  <TextTitleCompressedHeavyUpperCase
                    mb
                    style={{
                      fontSize: STYLES_FONT_SIZE.HEADING_SMALL
                    }}
                  >
                    {formatMessageIntlUtil(intl, titleMessage)}
                  </TextTitleCompressedHeavyUpperCase>
                  <TextBody>
                    {formatMessageIntlUtil(intl, descriptionMessage)}
                  </TextBody>
                </View>
              )
            })
          }
        </View>
        <View
          mt={4}
          centered
          style={{
            textAlign: 'center'
          }}
        >
          <WhoItsBuiltForCTA />
        </View>
      </View>
    </Block>
  )
}
